/* eslint-disable multiline-comment-style */
/* eslint react/sort-comp: 0 */
/* eslint-disable */
import PropTypes from "prop-types";
import React, { Component } from "react";
import { getAdTargets } from "../../utils/ads/setAdTargeting";
import { refreshAdSlot } from "../../utils/ads/webAdLib";
import {
  componentIsInRangeOfViewport,
  documentIsVisible,
  onHomepage,
} from "../../utils/dom";
import {map, get, includes,reduce} from "lodash";
import classnames from "classnames";
import {
  countAdsOnPageGenerator,
  getSlideAdCountValue,
} from "../../utils/ads/countAdsOnPage";
import RosettaFormattedMessage from "./rosetta_formatted_message";

const adCountGenerator = countAdsOnPageGenerator();
const LAZY_LOAD_CUSHION_PX = 300;
let page;

export default class Ad extends Component {
  shouldRefresh = false;
  shouldReconstruct = false;

  shouldRefreshFromSlideCount = (nextProps) => {
    const previousSlideChangeCount = this.props.adsState.slideChangeCount;
    const nextSlideChangeCount = nextProps.adsState.slideChangeCount;
    return (
      previousSlideChangeCount !== nextSlideChangeCount &&
      nextSlideChangeCount > 0 &&
      nextSlideChangeCount % this.props.refreshEveryNSlides === 0
    );
  };

  shouldReconstructFromRouteUpdate = (nextProps) =>
    !this.props.adsState.adTargetingCompleted &&
    nextProps.adsState.adTargetingCompleted;

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    this.shouldRefresh = this.shouldRefreshFromSlideCount(nextProps);
    this.shouldReconstruct = this.shouldReconstructFromRouteUpdate(nextProps);
  };

  shouldRefreshAdCountForNewPage = () =>
    page !== get(this.props, "adsState.ad_data.ad_pageid");

  componentDidUpdate() {
    if (this.shouldRefresh) {
      return this.refreshAdSlot();
    }
  }

  refreshAdSlot() {
    return refreshAdSlot(this.getId());
  }

  getAdCount = () => {
    const { position, adsState, slideshow } = this.props;
    const { ad_data } = adsState || {};
    const { ad_pageid } = ad_data || {};
    const { location } = this.context;

    /*
     * Out of Page 1x1 ad always is in position 1
     * Out of Page adhesion is always in position 2
     * Out of Page Interstitial is always in position 3
     * Native Ad is always in position 4
     * All other ads start at position 5
     *
     * 1x1 and Native do not use ad.js
     * 1x1 is defined in js/utils/ads/addSlimcutAdSlot.js
     * Native Ad is defined in js/components/common/native_ad.js
     */

    if (position === "adhesion") {
      return 2;
    } else if (position === "interstitial") {
      return 3;
    } else if (slideshow) {
      return getSlideAdCountValue(position, location);
    }

    let numberAds = adCountGenerator.next().value;
    if (this.shouldRefreshAdCountForNewPage()) {
      page = ad_pageid;
      numberAds = adCountGenerator.next(true).value;
    }
    return numberAds;
  };

  getSlotIdQualifier() {
    const { adsState, onFullWidthArticle, position, scrollAdPosition } =
      this.props;
    const ad_page_type = get(adsState, "ad_data.ad_page_type");
    const uniqueScrollSlot =
      position === "A" &&
      includes(ad_page_type, "scrollable") &&
      scrollAdPosition;
    const slotPosition =
      scrollAdPosition && !includes(["bottom", "top"], position)
        ? "scroll"
        : position;
    const qualifiers = {
      "full-width": onFullWidthArticle,
      [slotPosition]: true,
      related: position.startsWith("related"),
      A: uniqueScrollSlot,
    };
    return reduce(
      qualifiers,
      (acc, value, key) => (value === true ? `${acc}-${key}` : acc),
      ""
    );
  }

  adUnitIsGlobal() {
    const { position } = this.props;
    return includes(["adhesion", "interstitial"], position);
  }

  getSlotId() {
    const { adsState, position } = this.props;
    // returning an empty slot id disables slot registration for VICEMedia/web-ad-lib.
    const disable = get(adsState, "ad_data.ad_disable_all_ads");
    if (disable) {
      return "";
    }
    if (this.adUnitIsGlobal()) {
      return position;
    }
    const adPageType = get(adsState, "ad_data.ad_page_type", "");
    const { edition_data, location } = this.context;
    const contextualTemplate = onHomepage(location, edition_data)
      ? "homepage"
      : adPageType;
    const template = contextualTemplate.replace("Full-Width ", "");
    return `${template}${this.getSlotIdQualifier()}`;
  }

  getTargeting() {
    const { adsState } = this.props;
    const { ad_data } = adsState || {};
    const { location } = this.context;
    const targeting = {
      ...getAdTargets(ad_data, location),
      ad_count: this.getAdCount(),
    };
    
    return JSON.stringify(targeting, (key, value) =>
      typeof value === "undefined" ? null : value
    );
  }

  /*
   * Checks the pagetype and ad position to navigate
   * which htlbid className to apply to the ad.
   *
   * Current htlbid classes not being applied
   * '1x1': '.htlad-1x1'
   * '1x5': '.htlad-1x5'
   * 'promo-homepage': '.htlad-native-homepage'
   * 'promo-section': '.htlad-native-section'
   */
  getHtlBidClass() {
    const { adsState, position } = this.props;
    const adPageType = get(adsState, "ad_data.ad_page_type", "");

    let classname;
    switch (adPageType) {
      case "aggregation":
      case "homepage":
        classname = "htlad-ad-feed-row-scroll";
        if (position.includes("header")) {
          classname = "htlad-ad-header";
        }
        if (position.includes("adhesion")) {
          classname = "htlad-1x1";
        }
        if (position.includes("top")) {
          classname = "htlad-ad-feed-row-top";
        }
        if (position.includes("promo-homepage")) {
          classname = "htlad-native-homepage";
        }
        break;

      case "slideshow":
        classname = "htlad-ad-ss-scroll";
        if (position.includes("header")) {
          classname = "htlad-ad-header";
        }
        if (position.includes("top")) {
          classname = "htlad-ad-ss-top";
        }
        if (position.includes("right")) {
          classname = "htlad-ad-right-rail";
        }
        if (position.includes("bottom")) {
          classname = "htlad-ad-section-ad-bottom";
        }
        if (position.includes("related")) {
          classname = "htlad-ad-feed-row";
        }
        if (position.includes("1x1") || position.includes("adhesion")) {
          classname = "htlad-1x1";
        }
        if (position.includes("1x5") || position.includes("invusion")) {
          classname = "htlad-1x5";
        }
        break;

      case "scrollable": // shortform
        classname = "htlad-ad-section-ad-scroll";
        if (position.includes("header")) {
          classname = "htlad-ad-header";
        }
        if (position.includes("right")) {
          classname = "htlad-ad-right-rail";
        }
        if (position.includes("top") || position === 'A') {
          classname = "htlad-ad-section-ad-top";
        }
        if (position.includes("related")) {
          classname = "htlad-ad-related-content-row";
        }
        if (position.includes("bottom")) {
          classname = "htlad-ad-section-ad-bottom";
        }
        if (position.includes("1x1") || position.includes("adhesion")) {
          classname = "htlad-1x1";
        }
        if (position.includes("1x5") || position.includes("invusion")) {
          classname = "htlad-1x5";
        }
        break;

      case "Full-Width scrollable": // longform
        classname = "htlad-ad-section-ad-scroll";
        if (position.includes("header")) {
          classname = "htlad-ad-header";
        }
        if (position.includes("related")) {
          classname = "htlad-ad-feed-row";
        }
        if (position.includes("right")) {
          classname = "htlad-ad-feed-row";
        }
        if (position.includes("bottom")) {
          classname = "htlad-ad-section-ad-bottom";
        }
        if (position.includes("top") || position === 'A') {
          classname = "htlad-ad-section-ad-top";
        }
        if (position.includes("1x1") || position.includes("adhesion")) {
          classname = "htlad-1x1";
        }
        if (position.includes("1x5") || position.includes("invusion")) {
          classname = "htlad-1x5";
        }
        break;
    }

    return classname;
  }

  adIsVisible() {
    if (typeof window !== "undefined") {
      return (
        documentIsVisible(document) &&
        componentIsInRangeOfViewport(
          this._node,
          this.props.lazyLoadCushionPx,
          window
        )
      );
    }
  }

  getId = () => `ad-${this.props.uniqueId}`;

  render() {
    const sizes = map(this.props.sizes, ([h, w]) => `${h}x${w}`).join(",");
    const adClasses = classnames(
      "ad",
      this.getHtlBidClass(),
      this.props.className
    );

    return (
      <>
        {this.props.showAdCallout && 
          <RosettaFormattedMessage
            parentFilename={__filename}
            id="header"
            description="Ad Placeholder"
            defaultMessage="Ad"
            className="header"
          />
        }
        <div
          className={adClasses}
          data-ad-size={sizes}
          data-ad-position={this.props.position}
          data-slot-id={this.getSlotId()}
          data-targeting={this.getTargeting()}
          id={this.getId()}
          ref={(node) => (this._node = node)}
        ></div>
      </>
    );
  }
}

const AdSizeType = PropTypes.arrayOf(PropTypes.number.isRequired);

Ad.propTypes = {
  adsState: PropTypes.shape({
    ad_data: PropTypes.object,
    adTargetingCompleted: PropTypes.bool,
    slideChangeCount: PropTypes.number,
  }).isRequired,
  uniqueId: PropTypes.string.isRequired,
  sizes: PropTypes.arrayOf(AdSizeType.isRequired).isRequired,
  position: PropTypes.string.isRequired,
  scrollAdPosition: PropTypes.bool,
  className: PropTypes.string,
  outOfPage: PropTypes.bool,
  refreshOnInterval: PropTypes.bool,
  useSlideshowAdIntervalRefresher: PropTypes.bool,
  shouldDisplayImmediately: PropTypes.bool,
  refreshEveryNSlides: PropTypes.number,
  lazyLoadCushionPx: PropTypes.number,
  slideshow: PropTypes.bool,
  onFullWidthArticle: PropTypes.bool,
  showAdCallout: PropTypes.bool,
};

Ad.defaultProps = {
  adsState: {},
  scrollAdPosition: false,
  sizes: [],
  refreshEveryNSlides: 0,
  lazyLoadCushionPx: LAZY_LOAD_CUSHION_PX,
  useSlideshowAdIntervalRefresher: false,
  slideshow: false,
  onFullWidthArticle: false,
  showAdCallout: true,
};

Ad.contextTypes = {
  channels: PropTypes.arrayOf(PropTypes.string),
  edition_data: PropTypes.object,
  location: PropTypes.object,
};
